import React from 'react'

import Button from '../Button/Button'
import BoxSlider from '../BoxSlider/BoxSlider'
import './Languages.css'

const items = [
  {
    text: 'Javascript',
    icon: require('./img/javascript.png'),
    style: {
      background: '#17c6fa',
    },
  },
  {
    text: 'PHP',
    icon: require('./img/php.png'),
    style: {
      background: '#7e3fdb',
    },
  },
  {
    text: 'MySQL',
    icon: require('./img/mysql.png'),
    style: {
      background: '#19d0cf',
    },
  },
  {
    text: 'React',
    icon: require('./img/react.svg'),
    style: {
      background: '#00d8ff',
    },
  },
  {
    text: 'HTML5',
    icon: require('./img/html5.png'),
    style: {
      background: '#e8c466',
    },
  },
  {
    text: 'MongoDB',
    icon: require('./img/mongodb-leaf.svg'),
    style: {
      background: '#69b240',
    },
  },
  {
    text: 'AWS',
    icon: require('./img/aws.svg'),
    style: {
      background: '#ff9900',
    },
  },
  {
    text: 'Redis',
    icon: require('./img/redis.svg'),
    style: {
      background: '#d82f27',
    },
  },
  {
    text: 'Redux',
    icon: require('./img/redux.svg'),
    style: {
      background: '#764abc',
    },
  },
  {
    text: 'Vue',
    icon: require('./img/vue.svg'),
    style: {
      background: '#42b983',
    },
  },
  {
    text: 'Ruby',
    icon: require('./img/ruby.svg'),
    style: {
      background: '#a10d00',
    },
  },
  {
    text: 'PostgreSQL',
    icon: require('./img/PostgreSQL.svg'),
    style: {
      background: '#336791',
    },
  },
  {
    text: 'CSS',
    icon: require('./img/css.png'),
    style: {
      background: '#e48a5a',
    },
  },
]

const LanguagesAndFrameworks = () => (
  <div className="fmbm-languages">
    <div className="fmbm-languages__top" />
    <div className="fmbm-languages__container">
      <div className="fmbm-languages__header">Languages & Frameworks</div>
      <div className="fmbm-languages__slider">
        <BoxSlider items={items} />
      </div>
      <div className="fmbm-languages__cta">
        <div className="fmbm-languages__cta-text">
          Working on something cool? Drop us a message.
        </div>
        <Button
          href="https://goo.gl/forms/Ic1vg0nIpl8qfdi22"
          buttonText="Contact us"
          style={{ backgroundColor: '#13d4ff' }}
        />
      </div>
      <div className="fmbm-languages__circle1" />
      <div className="fmbm-languages__circle2" />
      <div className="fmbm-languages__circle3" />
      <div className="fmbm-languages__circle4" />
    </div>
  </div>
)

export default LanguagesAndFrameworks



// WEBPACK FOOTER //
// ./src/Components/Languages/Languages.js